module.exports = __webpack_public_path__ + "05_medium_black.aad66dbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_medium_black.png
// module id = J+1a
// module chunks = 0